import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { withTheme } from "shared/context/Theme";
import { Search as Icon } from "backpack-ui/dist/components/icon";
import { SEARCH_HOST } from "../../navigation/config";
import InputModal from "./InputModal";
import themes from "./themes";
import styles from "./styles.css";

class Desktop extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isActive: false };
  }

  componentDidMount = () => {
    if (typeof document !== "undefined") {
      const tabletNavSearchLink = document.querySelector(
        "#search-heading-desktop a"
      );

      if (tabletNavSearchLink) {
        // This listener is only so tablet search nav link triggers modal, too.
        // In previous (rizzo-next) version of GlobalHeader, tablet search was
        // just a direct link to the search page, but it was decided to change
        // it in order to support the new search autocomplete on all devices.
        tabletNavSearchLink.addEventListener("click", this.setActive);
      }
    }
  };

  setActive = (event) => {
    event.preventDefault();
    this.setState({ isActive: true });
  };

  setInactive = () => {
    this.setState({ isActive: false });
  };

  render() {
    const {
      theme,
      className,
      searchTerm,
      searchResults,
      onChange,
    } = this.props;
    const { isActive } = this.state;

    return (
      <React.Fragment>
        <a
          href={SEARCH_HOST}
          id="search-desktop"
          className={cn({
            [theme.styles.container]: true,
            [theme.styles.isActive]: isActive,
            [className]: className,
          })}
          onClick={this.setActive}
        >
          <Icon className={theme.styles.icon} />
          <span className={theme.styles.title}>Search Lonely Planet</span>
        </a>
        <InputModal
          isOpen={isActive}
          onRequestClose={this.setInactive}
          searchTerm={searchTerm}
          searchResults={searchResults}
          onChange={onChange}
        />
      </React.Fragment>
    );
  }
}

Desktop.propTypes = {
  theme: PropTypes.shape({
    styles: PropTypes.shape({}).isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  searchResults: PropTypes.arrayOf(PropTypes.shape({})),
  className: PropTypes.string,
};

Desktop.defaultProps = {
  searchTerm: "",
  searchResults: [],
  className: "",
};

export default withTheme(Desktop, styles, themes);
